<template>
  <div>
    <p>
      {{ label }} {{ direction }} text messsage (<a :href="link" >Inbox</a>)
      <template v-if="triggerMetaData">
        <br>
        {{ triggerMetaData.message }} (<a :href="triggerLink">Message Response</a>)
      </template>
    </p>
    <div class="object-details pre-line">{{details.message_text}} </div>
  </div>
</template>

<script>
export default {
  name: "TextMessage",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
    direction() {
      return this.details.direction == 'inbound' ? 'inbound' : 'outbound';
    },
    link() {
      return `${this.$config.baseUrl}/i/${this.details.participant_id}`;
    },
    triggerMetaData() {
      if (!this.details.metadata) {
        return null;
      }
      return this.details.metadata.find(md => md.hasOwnProperty('trigger_id'));
    },
    triggerLink() {
      return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/messaging/triggers/${this.triggerMetaData.trigger_id}/edit`;
    }
  }
}
</script>

<style scoped>

</style>